import Base from "./Base";
import React from "react";
import WhatsAppButton from "./WhatsAppButton";
// import BetaMessage from "./BetaMessage";

export default function Home() {
  const customShadow = '-8px -8px 18px #06bfee, 8px 8px 8px #095370';
  // const [showBetaMessage, setShowBetaMessage] = useState(true);

  // const closeBetaMessage = () => {
  //   setShowBetaMessage(false);
  // };

  return (
    <div>
      <Base description="" title="" box_Shadow={customShadow}>
        <div style={{ 
          textAlign: "center", 
          color: "white", 
          padding: "20px" // Optional: adds some breathing room from the edge
            }}>
          {/* {showBetaMessage && <BetaMessage onClose={closeBetaMessage} />} */}
          <h1 style={{ 
            margin: 0,
            // Standard professional font stack
            fontFamily: "Inter, system-ui, -apple-system, sans-serif", 
            fontWeight: "700",
            textTransform: "uppercase",
            letterSpacing: "1px",
            // Drop shadow: horizontal, vertical, blur, and color
            textShadow: "2px 2px 8px rgba(0, 0, 0, 0.6)" 
            }}>
            WorkWise - UAE
          </h1>
        </div>
        <WhatsAppButton />
      </Base>
    </div>
  );
}

